import { auditReports } from '@mi-front/api-clients';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, Stack } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import { GipEvidenceExportConfigForm } from './GipEvidenceExportConfigForm';
import { gipExportMessages } from './messages';

interface Props {
  show: boolean;
  onHide: () => void;
  initialConfig?: auditReports.GipEvidenceExportOptionsDto;
  reportType: string;
  onSubmit: (data: auditReports.GipEvidenceExportOptionsDto) => Promise<void>;
}

export function GipExportDialog(p: Props) {
  return (
    <Dialog open={p.show} onClose={p.onHide} maxWidth="sm" fullWidth>
      <DialogTitle>
        <FormattedMessage {...gipExportMessages.title} />
      </DialogTitle>
      <GipEvidenceExportConfigForm
        initialConfig={p.initialConfig}
        reportType={p.reportType}
        onSubmit={async (data: auditReports.GipEvidenceExportOptionsDto) => {
          await p.onSubmit(data);
          p.onHide();
        }}
        ContentWrapper={DialogContent}
        actions={
          <DialogActions className="dialog-actions">
            <Stack direction="row" spacing={2}>
              <Button variant="outlined" onClick={p.onHide}>
                <FormattedMessage id="common.actions.cancel" defaultMessage="Cancelar" />
              </Button>
              <Button type="submit" variant="contained" color="primary">
                <FormattedMessage {...gipExportMessages.startBtn} />
              </Button>
            </Stack>
          </DialogActions>
        }
      />
    </Dialog>
  );
}
